require('./app');

$(function () {
    let modals = $('.modal');

    modals.on('shown.bs.modal', function () {
        if ($(window).width() < 768) {
            modals.css('height', $(window).height() - 50);
            $('body').css('overflow', 'hidden');
        }
    });

    modals.on('hidden.bs.modal', function () {
        if ($(window).width() < 768) $('body').css('overflow', '');
    });

    $(document).on("click", ".lost-password-toggle", function () {
        var email = $(this).data('email');
        $("#forgot-password-modal #forgotten_user_email").val(email);
    });

    $('.email-name-brochure-link').on('click', function () {
        let propertyId = $(this).data('property-id'),
            IDField = $('#name-email-brochure-form-object #property-id');

        IDField.val(propertyId);
    });

    if ($('#name-email-brochure-form-object').length) {
        if (window.helpers.readCookie('brochure_half_gate_first_name')) { $('#brochure_firstname').val(window.helpers.readCookie('brochure_half_gate_first_name')); }
        if (window.helpers.readCookie('brochure_half_gate_last_name')) { $('#brochure_lastname').val(window.helpers.readCookie('brochure_half_gate_last_name')); }
        if (window.helpers.readCookie('brochure_half_gate_email')) { $('#brochure_email').val(window.helpers.readCookie('brochure_half_gate_email')); }
        if (window.helpers.readCookie('brochure_half_gate_home_address')) { $('#brochure_home_address').val(window.helpers.readCookie('brochure_half_gate_home_address')); }
        if (window.helpers.readCookie('brochure_half_gate_city')) { $('#brochure_city').val(window.helpers.readCookie('brochure_half_gate_city')); }
        if (window.helpers.readCookie('brochure_half_gate_state')) { $('#brochure_state').val(window.helpers.readCookie('brochure_half_gate_state')); }
        if (window.helpers.readCookie('brochure_half_gate_zip')) { $('#brochure_zip').val(window.helpers.readCookie('brochure_half_gate_zip')); }
    }

    $('#name-email-brochure-form-object').validate({
        submitHandler: function (form, e) {
            e.preventDefault();

            console.log('here');

            $('#name-email-brochure .spinner-overlay').show();

            let propertyId = $('#name-email-brochure-form-object #property-id').val(),
                firstName = $('#brochure_firstname').val(),
                lastName = $('#brochure_lastname').val(),
                email = $('#brochure_email').val(),
                address = $('#brochure_home_address').val(),
                city = $('#brochure_city').val(),
                state = $('#brochure_state').val(),
                zip = $('#brochure_zip').val(),
                contactType = $('#brochure_contact_type').val();

            if (window.helpers.readCookie('brochure_half_gate_first_name')) { window.helpers.eraseCookie('brochure_half_gate_first_name'); }
            if (window.helpers.readCookie('brochure_half_gate_last_name')) { window.helpers.eraseCookie('brochure_half_gate_last_name'); }
            if (window.helpers.readCookie('brochure_half_gate_email')) { window.helpers.eraseCookie('brochure_half_gate_email'); }
            if (window.helpers.readCookie('brochure_half_gate_home_address')) { window.helpers.eraseCookie('brochure_half_gate_home_address'); }
            if (window.helpers.readCookie('brochure_half_gate_city')) { window.helpers.eraseCookie('brochure_half_gate_city'); }
            if (window.helpers.readCookie('brochure_half_gate_state')) { window.helpers.eraseCookie('brochure_half_gate_state'); }
            if (window.helpers.readCookie('brochure_half_gate_zip')) { window.helpers.eraseCookie('brochure_half_gate_zip'); }

            window.helpers.createCookie('brochure_half_gate_first_name', firstName, 120);
            window.helpers.createCookie('brochure_half_gate_last_name', lastName, 120);
            window.helpers.createCookie('brochure_half_gate_email', email, 120);
            window.helpers.createCookie('brochure_half_gate_home_address', address, 120);
            window.helpers.createCookie('brochure_half_gate_city', city, 120);
            window.helpers.createCookie('brochure_half_gate_state', state, 120);
            window.helpers.createCookie('brochure_half_gate_zip', zip, 120);

            $.post("/wp/wp-admin/admin-ajax.php", {
                'action': 'email_name_brochure',
                'property_id': propertyId,
                'first_name': firstName,
                'last_name': lastName,
                'email': email,
                'address': address,
                'city': city,
                'state': state,
                'zip': zip,
                'contactType': contactType
            }, function (data) {
                var win = window.open(data, '_blank');
                // window.location.href = data;
                if (!win || win.closed || typeof win.closed == 'undefined') {
                    window.location.href = data;
                } else {
                    location.reload();
                }
            });

            window.helpers.gaEvent('Brochures', 'brochure-downloaded-email-only-gate', propertyId);
        }
    });
});
